/* eslint-disable no-return-assign */
/* eslint-disable no-await-in-loop */
/* eslint-disable prefer-promise-reject-errors */
/* eslint-disable no-unused-vars */
/* eslint-disable no-console */
import { makeAutoObservable, runInAction } from 'mobx';
import queryString from 'query-string';
import axios from 'axios';
// import { downloadZip } from 'client-zip';

import 'core-js/stable';
import 'regenerator-runtime/runtime';
import streamSaver from 'streamsaver';

import { API, APIRoutes } from '@api';
import { setItem, getItem, KEYS } from '@app/cache';
import { routerStore } from '@stores';
import routes from '@routes';
import { history } from '@app/history';
import { tracksOptions, stemsOptions } from '@app/consts';
import dayjs from 'dayjs';
import { ZIP } from '../utils/Zip64';

streamSaver.mitm = `/streamsaver/mitm.html`;

const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

export class MusicStore {
  isLoading = false;

  albums = [];

  tracks = [];

  album = {};

  labels = [];

  labelsLoading = false;

  searchPhrase = '';

  view = getItem(KEYS.LIST_VIEW) || 'list';

  meta = null;

  perPage = 24;

  page = 1;

  totalPages = null;

  downloading = false;

  downloadProgress = {};

  error = null;

  selectedLabelUUID = null;

  kind = 'albums';

  selectedAlbums = [];

  order = { by: 'directory_name', dir: 'desc' };

  constructor() {
    makeAutoObservable(this);
  }

  createTemporaryLink = url => {
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', '');

    link.click();
    link.remove();

    // wait 3 seconds to hide preparing download modal
    runInAction(() => {
      setTimeout(() => {
        this.downloading = false;
      }, 3000);
    });
  };

  downloadCover = async () => {
    try {
      const image = await fetch(this.album.cover.original_url);
      const imageBlog = await image.blob();
      const imageURL = URL.createObjectURL(imageBlog);

      const link = document.createElement('a');
      link.href = imageURL;
      link.download = this.album.uuid;

      link.click();
      link.remove();
      URL.revokeObjectURL(imageURL);
    } catch (error) {
      console.error(error);
    } finally {
      runInAction(() => {
        this.downloading = false;
      });
    }
  };

  downloadMetaData = async url => {
    try {
      this.downloading = true;

      const { data, headers } = await axios(url, {
        responseType: 'blob',
      });

      const fileName = headers['content-disposition']
        ?.split('filename=')[1]
        ?.split(';')[0]
        ?.replaceAll('"', '');

      const tempUrl = URL.createObjectURL(new Blob([data]));
      const link = document.createElement('a');
      link.href = tempUrl;
      link.download = fileName;

      link.click();
      link.remove();
      URL.revokeObjectURL(tempUrl);
    } catch (error) {
      console.error(error);
    } finally {
      runInAction(() => {
        this.downloading = false;
      });
    }
  };

  downloadBatch = async option => {
    const { value: kind, type } = option;
    this.downloading = true;

    if (type === 'meta') {
      this.downloadMetaData(
        APIRoutes.DOWNLOAD_META_BATCH(this.selectedAlbums, kind),
      );
    } else {
      const { data: tracks } = await axios(
        APIRoutes.DOWNLOAD_MUSIC_BATCH(this.selectedAlbums, kind, true),
      );

      const kindLabel =
        [...tracksOptions, ...stemsOptions].find(o => o.value === kind)
          ?.label || 'Music files';
      const zipName = `${kindLabel}`;

      if (isSafari) {
        this.createTemporaryLink(
          APIRoutes.DOWNLOAD_MUSIC_BATCH(this.selectedAlbums, kind),
        );
      } else {
        this.downloadClientZip(tracks, zipName);
      }
    }
  };

  downloadAlbum = async (album, option) => {
    const { value: kind, type } = option;
    this.downloading = true;

    if (type === 'meta') {
      this.downloadMetaData(APIRoutes.DOWNLOAD_META_BATCH([album.uuid], kind));
    } else if (type === 'cover') {
      this.downloadCover();
    } else {
      try {
        const { data: tracks } = await axios(
          APIRoutes.DOWNLOAD_MUSIC_BATCH([album.uuid], kind, true),
        );

        const kindLabel =
          [...tracksOptions, ...stemsOptions].find(o => o.value === kind)
            ?.label || 'Music files';
        const zipName = `${album.directory_name}-${kindLabel}`;

        if (isSafari) {
          this.createTemporaryLink(
            APIRoutes.DOWNLOAD_MUSIC_BATCH([album.uuid], kind),
          );
        } else {
          this.downloadClientZip(tracks, zipName);
        }
      } catch (error) {
        console.error(error);
      }
    }
  };

  downloadTracks = async (ids, option) => {
    const { value: kind } = option;
    this.downloading = true;

    try {
      const { data: tracks } = await axios(
        APIRoutes.DOWNLOAD_TRACKS_ZIP(ids, kind, true),
      );

      const zipName = `Tracks - ${dayjs(new Date()).format('YYYY-MM-DD')}`;

      if (isSafari) {
        const fallbackUrl = APIRoutes.DOWNLOAD_TRACKS_ZIP(ids, kind);

        setTimeout(() => {
          this.createTemporaryLink(fallbackUrl);
        }, 100);
      } else {
        this.downloadClientZip(tracks, zipName);
      }
    } catch (error) {
      console.error(error);
    }
  };

  downloadGoogleApis = async url => {
    try {
      this.downloading = true;

      const { data } = await axios(url, {
        responseType: 'blob',
      });

      const fileName = url.replace(/^.*[\\/]/, '');

      const tempUrl = URL.createObjectURL(new Blob([data]));
      const link = document.createElement('a');
      link.href = tempUrl;
      link.download = fileName;

      link.click();
      link.remove();
      URL.revokeObjectURL(tempUrl);
    } catch (error) {
      console.error(error);
    } finally {
      runInAction(() => {
        this.downloading = false;
      });
    }
  };

  updateSelectedAlbums = albums => {
    this.selectedAlbums = albums;
  };

  setSort = by => {
    try {
      const dir = this.order.dir === 'asc' ? 'desc' : 'asc';

      runInAction(() => {
        this.order = {
          by,
          dir,
        };
      });

      const order = `${by}_${dir}`;

      const params = routerStore.location.search;
      const queryParams = queryString.parse(params);
      queryParams.o = order;
      routerStore.push(
        `${routes.label(
          this.selectedLabelUUID,
          this.selectedKind,
        )}?${queryString.stringify(queryParams)}`,
      );
    } catch (error) {
      console.warn(error); // eslint-disable-line no-console
    }
  };

  search = async phrase => {
    try {
      if (phrase) {
        routerStore.push(
          `${routes.label(
            this.selectedLabelUUID,
            this.selectedKind,
          )}?q=${phrase}`,
        );
      } else {
        routerStore.push(
          routes.label(this.selectedLabelUUID, this.selectedKind),
        );
      }
    } catch (error) {
      console.warn(error); // eslint-disable-line no-console
    }
  };

  toggleView = view => {
    this.view = view;
    setItem(KEYS.LIST_VIEW, view);
  };

  fetchLabels = async labelUUID => {
    if (!this.labelsLoading && this.labels.length === 0) {
      this.labelsLoading = true;
      try {
        const {
          data: { labels },
        } = await API.get(APIRoutes.LABELS);

        runInAction(() => {
          this.labels = labels;
          this.selectLabel(labelUUID);
        });
      } catch (error) {
        this.error = error;
      } finally {
        runInAction(() => {
          this.labelsLoading = false;
        });
      }
    }
  };

  selectLabel = (uuid, kind = 'albums') => {
    if (history.location.pathname.includes('labels')) {
      if (this.labels.length) {
        if (!uuid) {
          const [firstLabel] = this.labels;
          routerStore.replace(`${routes.label(firstLabel.uuid)}`);
          this.selectedLabelUUID = firstLabel.uuid;
        } else {
          this.selectedLabelUUID = uuid;
        }
        this.selectedKind = kind;
      }
    }
  };

  fetchData = async (labelUUID, stems = false) => {
    runInAction(() => {
      this.isLoading = true;
    });

    try {
      const {
        q: searchPhrase,
        p: page,
        per: perPage,
        o: order,
      } = queryString.parse(routerStore.location.search);

      runInAction(() => {
        this.searchPhrase = searchPhrase || '';
        this.page = page || 1;
      });

      const { data } = await API.get(
        APIRoutes.ALBUMS_BY_LABEL(
          labelUUID,
          stems,
          page,
          perPage,
          searchPhrase,
          order,
        ),
      );

      runInAction(() => {
        this.albums = data.albums;
        this.meta = data.meta;
        this.totalPages = Math.ceil(this.meta.total_count / this.perPage);
      });
    } catch (error) {
      console.warn(error); // eslint-disable-line no-console
    } finally {
      runInAction(() => {
        this.isLoading = false;
      });
    }
  };

  fetchAlbum = async (uuid, stems = false) => {
    runInAction(() => {
      this.isLoading = true;
    });

    try {
      const { data } = await API.get(APIRoutes.ALBUM(uuid, stems));

      runInAction(() => {
        this.album = data.album;
      });
    } catch (error) {
      console.warn(error); // eslint-disable-line no-console
    } finally {
      runInAction(() => {
        this.isLoading = false;
      });
    }
  };

  switchPage = page => {
    const params = routerStore.location.search;
    const queryParams = queryString.parse(params);
    queryParams.p = page + 1;
    routerStore.push(
      `${routes.label(
        this.selectedLabelUUID,
        this.selectedKind,
      )}?${queryString.stringify(queryParams)}`,
    );
  };

  resetAlbum = () => {
    this.album = {};
  };

  resetAlbums = () => {
    this.albums = [];
  };

  resetTracks = () => {
    this.albums = [];
  };

  eventListener = event => {
    return (event.returnValue = '');
  };

  downloadClientZip = async (tracks, zipName) => {
    const files = tracks.values();

    window.addEventListener('beforeunload', this.eventListener);

    const fileStream = streamSaver.createWriteStream(`${zipName}.zip`);

    const readableZipStream = new ZIP({
      async pull(ctrl) {
        const { done, value } = files.next();
        if (done) return ctrl.close();
        const url = value[0];
        const { body, headers } = await fetch(url);
        return ctrl.enqueue({
          name: value[1],
          stream: () => body,
        });
      },
    });

    readableZipStream
      .pipeTo(fileStream)
      .then(() => {
        window.removeEventListener('beforeunload', this.eventListener);
      })
      .catch(_error => {
        console.log('Download corrupted');
        console.log(_error);
        window.removeEventListener('beforeunload', this.eventListener);
      });

    this.downloading = false;
  };
}

export default new MusicStore();
